import React from "react";
import './Loader.css'

export function Loader(){
    return <div className="m">
            <div className="l"></div>
        </div>
}

export default Loader;